import React, { useState } from "react";

const ContentTab = ({ updateClickToCallTabData, clickToCallTabData }) => {
    const [activeContentElementsTab, setActiveContentElementsTab] = useState("main");
    const [phoneNumber, setPhoneNumber] = useState(clickToCallTabData.content_phone_number);
    const [showButtonIcon, setShowButtonIcon] = useState(Number(clickToCallTabData.content_is_show_button_icon));
    const [showButtonText, setShowButtonText] = useState(clickToCallTabData.content_button_text);
    const [chatWindowImage, setChatWindowImage] = useState(clickToCallTabData.content_call_window_picture);
    const [showCallWindowName, setCallWindowName] = useState(clickToCallTabData.content_call_window_name);
    const [showCallWindowCaption, setCallWindowCaption] = useState(clickToCallTabData.content_call_window_caption);
    const [showCallWindowMessage, setCallWindowMessage] = useState(clickToCallTabData.content_call_window_message);
    const [showFormatPhoneNumber, setFormatPhoneNumber] = useState(Number(clickToCallTabData.content_call_window_format_phone_number));

    // Handlers Phone Number Change
    const handleInputChange = (event) => {
        const value = event.target.value;
        setPhoneNumber(value);
        updateClickToCallTabData("content_phone_number", value);
    };

    // Handlers Show Button Icon Change
    const handleShowButtonIconChange = (e) => {
        const checked = e.target.checked;
        setShowButtonIcon(checked);
        updateClickToCallTabData("content_is_show_button_icon", checked); 
    };

    // Handlers Show Button Text Change
    const handleShowButtonTextChange = (e) => {
        const value = e.target.value;
        setShowButtonText(value);
        updateClickToCallTabData("content_button_text", value); 
    };

    // Handlers Call Window Image Change
    const handleChatWindowImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setChatWindowImage(URL.createObjectURL(file));
            updateClickToCallTabData("content_call_window_picture", file);
        }
    }

    // Handlers Show Call Window Name Change
    const handleCallWindowNameChange = (e) => {
        const value = e.target.value;
        setCallWindowName(value);
        updateClickToCallTabData("content_call_window_name", value); 
    };

    // Handlers Show Call Window Caption Change
    const handleCallWindowCaptionChange = (e) => {
        const value = e.target.value;
        setCallWindowCaption(value);
        updateClickToCallTabData("content_call_window_caption", value); 
    };

    // Handlers Show Call Window Message Change
    const handleCallWindowMessageChange = (e) => {
        const value = e.target.value;
        setCallWindowMessage(value);
        updateClickToCallTabData("content_call_window_message", value); 
    };

    // Handlers Format Phone Number Change
    const handleFormatPhoneNumberChange = (e) => {
        const checked = e.target.checked;
        setFormatPhoneNumber(checked);
        updateClickToCallTabData("content_call_window_format_phone_number", checked); 
    };

    return (
        <div className="click-to-call-side-baar-content-tab">
            {activeContentElementsTab === "main" && (
                <>
                    <span>Content </span>
                    <div className="source-serach-baar">
                        <div className="google-search-container">
                            <input type="text" value={phoneNumber} onChange={handleInputChange} placeholder="Phone Number" />
                        </div>
                    </div>
                    <p>Enter the phone number you'd like to get calls from your website visitors.</p>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveContentElementsTab("button")}>Button <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveContentElementsTab("call_window")}>Call Window <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeContentElementsTab === "button" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveContentElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Button</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Show Button Icon</span>
                                <div className="form-group">
                                    <input id="content_show_button_icion_toggle" className="chkbx-toggle" type="checkbox" checked={showButtonIcon} onChange={handleShowButtonIconChange} />
                                    <label for="content_show_button_icion_toggle"></label>
                                </div>
                            </div>
                        </div>
                        <p>Show or hide phone icon in the button.</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row input-fild">
                                <label>Button Text</label>
                                <input type="text" value={showButtonText} onChange={handleShowButtonTextChange}placeholder="Type Button Text.." />
                            </div>
                        </div>
                        <p>Add some call to action text to the button, if necessary.</p>
                    </div>
                </>
            )}

            {activeContentElementsTab === "call_window" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveContentElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Call Window</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Picture</span>
                                <em>
                                    <button className="button-whtsapp picture">
                                        <img src={chatWindowImage} alt="Uploaded Preview" />
                                    </button>
                                </em>
                                <input 
                                    type="file" 
                                    accept="image/*" 
                                    onChange={handleChatWindowImageChange} 
                                />
                            </div>
                            <div className="box-header-row">
                                <input placeholder="Name" className="title-text" type="text" value={showCallWindowName} onChange={handleCallWindowNameChange} />
                            </div>
                            <div className="box-header-row">
                                <input placeholder="Caption" className="title-text" type="text" value={showCallWindowCaption} onChange={handleCallWindowCaptionChange} />
                            </div>
                            <div className="box-header-row">
                                <textarea id="editor" placeholder="Message..." value={showCallWindowMessage} onChange={handleCallWindowMessageChange}></textarea>
                            </div>
                        </div>
                        <p>Set the operator's info and add some call to action message to encourage your website visitors to call you.</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Format Phone Number</span>
                                <div className="form-group">
                                <input id="content_format_phone_number_toggle" className="chkbx-toggle" type="checkbox" checked={showFormatPhoneNumber} onChange={handleFormatPhoneNumberChange} />
                                <label for="content_format_phone_number_toggle"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ContentTab;